import Component from '../core/Component'
import withMedia from '../core/withMedia'
import Scroll from '../services/Scroll'

const defaults = {
    media: 'mediumUp',
}

class FooterFixedPortfolio extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            content: null,
        }

        this.state = {
            height: 0,
            limit: 0,
        }
    }
    prepare() {
        if(window.innerHeight >= 730 && window.innerWidth >= 1439) {
            Scroll.on('resize', this.handleResize)
            Scroll.on('scroll', this.handleScroll)
            this.resize()
            this.render(Scroll.getScroll().y)
        } else {
            return
        }
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
        this.ref.content.removeAttribute('style')
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = (data) => {
        this.render(data.offset.y)
    }

    resize() {
        const box = this.ref.content.getBoundingClientRect()
        this.state.height = box.height
        this.state.min = box.top + Scroll.getScroll().y
        this.state.limit = Scroll.getLimit().y
        this.element.style.height = this.state.height + 'px'
        this.render(Scroll.getScroll().y)
    }

    render(y) {
        if (this.state.limit - y > this.state.height) {
            return
        }

        this.ref.content.style.transform = `translateY(${Math.min(y - this.state.limit, 0)}px)`
    }
}

export default withMedia(FooterFixedPortfolio)
